import { PropertyTypeEnum } from 'api/real-estate';
import { InputContainer } from 'components/layout/Section/BaseSection';
import { FormikInputWithUnit } from 'components/forms/formik/FormikInputWithUnit';
import { FormikSelectCard } from 'components/forms/formik/FormikSelectCard';
import { NsKey } from 'enums/NsKey';
import { useDynamicTranslation } from 'hooks/useDynamicTranslation';
import { FC, useMemo } from 'react';
import { BorrowerRealEstateFormFieldNames } from './borrowerRealEstateForm';

export const BorrowerRealEstateDetailsSection: FC = () => {
  const { t } = useDynamicTranslation([NsKey.RealEstate, NsKey.Common]);

  const propertyTypeItems = useMemo(
    () => [
      { key: PropertyTypeEnum.Apartment, label: t('REAL_ESTATE.PROPERTY_TYPES.APARTMENT'), icon: 'building' },
      { key: PropertyTypeEnum.House, label: t('REAL_ESTATE.PROPERTY_TYPES.HOUSE'), icon: 'blueHouse' },
      { key: PropertyTypeEnum.Office, label: t('REAL_ESTATE.PROPERTY_TYPES.GARAGE'), icon: 'garage' },
      { key: PropertyTypeEnum.Commercial, label: t('REAL_ESTATE.PROPERTY_TYPES.COMMERCIAL'), icon: 'garage' }
    ],
    [t]
  );

  return (
    <div className="flex flex-col gap-4">
      <InputContainer>
        <div className="col-span-3">
          <FormikInputWithUnit
            name={BorrowerRealEstateFormFieldNames.Area}
            type="number"
            label={t('REAL_ESTATE.LABELS.AREA')}
            placeholder={t('REAL_ESTATE.PLACEHOLDERS.AREA')}
            unit="m²"
          />
        </div>
        <div className="col-span-3">
          <FormikInputWithUnit
            name={BorrowerRealEstateFormFieldNames.RoomCount}
            type="number"
            label={t('REAL_ESTATE.LABELS.ROOM_COUNT')}
            placeholder={t('REAL_ESTATE.PLACEHOLDERS.ROOM_COUNT')}
            unit="pcs"
            min={1}
            max={50}
            step={1}
          />
        </div>
      </InputContainer>
      <FormikSelectCard
        name={BorrowerRealEstateFormFieldNames.PropertyType}
        label={t('REAL_ESTATE.LABELS.PROPERTY_TYPE')}
        items={propertyTypeItems}
      />
    </div>
  );
};
